import type { GroupReaction } from '../../api';

/**
 * An item's emoji after this person chose `emoji` (null: took theirs off) — one per person per item, another replacing
 * it (Groups 2026-11-03). Drawn at once on a tap; the server's answer for the item then stands.
 */
export function withMine(list: GroupReaction[], emoji: string | null): GroupReaction[] {
  const out = list
    .map((r) => (r.mine ? { ...r, count: r.count - 1, mine: false } : r))
    .filter((r) => r.count > 0);
  if (!emoji) return out;
  const at = out.findIndex((r) => r.emoji === emoji);
  if (at >= 0) out[at] = { ...out[at], count: out[at].count + 1, mine: true };
  else out.push({ emoji, count: 1, mine: true });
  return out;
}

/** What a tap on a capsule does: theirs comes off; another becomes theirs. */
export function capsuleChoice(r: GroupReaction): string | null {
  return r.mine ? null : r.emoji;
}
